import type { CreateAdminModel, UpdateAdminModel } from '@/shared/api'

import type { AdminFormModel } from '..'

export function getAdminCreateRequestByFormValues(
  values: AdminFormModel,
): CreateAdminModel {
  return {
    login: values.login.trim(),
    password: values.password.trim(),
  }
}

export function getAdminUpdateRequestByFormValues(
  values: AdminFormModel,
): UpdateAdminModel {
  return {
    password: values.password.trim(),
  }
}
